import React, { useState, useEffect } from 'react';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { ConstantPermissions } from 'contexts/useConstant';
import ReactTable from 'components/ReactTable/ReactTable';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'components/CustomButtons/Button';
import { Add, Visibility } from '@material-ui/icons';
import CardHeader from 'components/Card/CardHeader';
import TextField from '@material-ui/core/TextField';
import { Toasty, useToasty } from 'hooks/Toasty';
import CardBody from 'components/Card/CardBody';
import CardIcon from 'components/Card/CardIcon';
import { WithApp } from 'contexts/appContext';
import Box from '@material-ui/core/Box';
import Card from 'components/Card/Card';
import { Link } from 'react-router-dom';
import { useModal } from 'hooks/useModal';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import Modal from 'components/Tvendo/Common/ModalBase';
import { wsGetAll, wsFindBy } from 'services/WService';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 120 },
  { Header: 'Zona', accessor: 'base_zone_description', width: 130 },
  { Header: 'Número inicial', accessor: 'initial_number', width: 160 },
  { Header: 'Último número', accessor: 'last_number', width: 160 },
  { Header: 'Siguiente número', accessor: 'next_number', width: 160 },
  { Header: 'Estado', accessor: 'state', width: 130 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const useClasses = makeStyles({
  cardTitle,
});

function ReferalGuide(props) {
  const classes = useClasses();
  const [guides, setGuides] = useState([]);
  const [notify, showNotify] = useToasty();
  const [model, setOpen] = useModal();
  const [dataLoading, setDataLoading] = useState(false);

  useEffect(() => {
    setDataLoading(true);
    wsGetAll('prt/guide-serie').then((response) => {
      setGuides(response.data)
      setDataLoading(false);
    });
  }, []);

  async function findGuides(filter) {
    setDataLoading(true);
    const response = await wsFindBy('prt/guide-serie', filter);
    setDataLoading(false);
    if (response.success) setGuides(response.data);
  }

  async function reload(){
    setDataLoading(true);
    wsGetAll('prt/guide-serie').then((response) => setGuides(response.data));
    setDataLoading(false);
  }

  return (
    <Card>
      <CardHeader icon>
        <AllowedGuard permission={ConstantPermissions.PRT_GUIDE_SERIES_STORE}>
          <CardIcon pointer="true" color="success" onClick={() => setOpen({})}>
            <Add style={{ color: 'white' }} />
          </CardIcon>
        </AllowedGuard>
        <h3 className={classes.cardTitle}>Listado de series guía remisión {dataLoading && <LoadingSpinner />}</h3>
      </CardHeader>
      <CardBody>
        <Toasty action={notify} />

        <StoreModal setOpen={setOpen} showNotify={showNotify} reload={reload} model={model} />

        <FilterCustom getFilter={findGuides} zone />
        <ReactTable
          defaultWidth={1000}
          formatDate="DD-MM-YYYY"
          columns={columns}
          data={guides.map((item, i) => {
            return {
              ...item,
              num: (
                <Box display="flex" alignItems="center">
                  {i + 1}
                  <Link to={`${item.id}`}>
                    <Button justIcon round simple color={props.themeContext.buttonColor}>
                      <Visibility />
                    </Button>
                  </Link>
                </Box>
              ),
              actions: '',
              state: item.state === 'A' ? 'Activo' : item.state === 'I' ? 'Inactivo' : item.state,
            };
          })}
        />
      </CardBody>
    </Card>
  );
}

function StoreModal(props) {
  const { model, setOpen, showNotify, reload } = props;
  const [zones, setZones] = useState([]);

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  useEffect(() => {
    if (model.open) listZones();
  }, [model.open]);

  return (
    <Modal
      title="Serie guía"
      model={model}
      setOpen={setOpen}
      showNotify={showNotify}
      reload={reload}
      entity="prt/guide-serie"
      state
    >
      <TextField
        label="Número inicial"
        type="number"
        name="initial_number"
        defaultValue={model.initial_number || ''}
        margin="normal"
        fullWidth
        required
      />
      <TextField
        label="Número final"
        type="number"
        name="last_number"
        defaultValue={model.last_number || ''}
        margin="normal"
        fullWidth
        required
      />
      <FormControl fullWidth margin="normal" required>
        <InputLabel>Zona</InputLabel>
        <Select
          defaultValue={model.base_zone_id || ''}
          inputProps={{
            name: 'base_zone_id',
          }}
        >
          {zones.map((zone, i) => {
            return (
              <MenuItem value={zone.id} key={i}>
                {zone.description}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Modal>
  );
}

export default WithApp(ReferalGuide);
